import React from "react";
import "./style.css";

function EditPolicy() {
  return (
    <div>
      <div className="card-body">
        <p>Edit Policy Stuff</p>
      </div>
    </div>
  );
}

export default EditPolicy;
